export const BEFORE = -1;
export const AFTER = 1;
export const INNER = 0;
export const RANGE = 0.25;
